import Pane from 'components/Common/Pane'
import OfferCardCarouselSectionFilters from 'components/Common/OfferCardCarousel/OfferCardCarouselSectionFilters'
import Group from 'components/utils/Group'
import {
  LOYALTY_OFFERS_HUB_ALL_INDUSTRY_FILTER,
  LOYALTY_OFFERS_HUB_PARTNER_OFFERS_HASH,
} from 'loyalty/lib/loyaltyOffersHub/constants'
import type { LoyaltyOffersHubIndustryFilterOption, LoyaltyOffersHubOffer } from 'loyalty/lib/loyaltyOffersHub/types'
import Heading from 'LuxKit/Typography/Heading'
import { useCallback, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import LoyaltyOffersHubOfferGrid from './LoyaltyOffersHubOfferGrid'

interface Props {
  offers: Array<LoyaltyOffersHubOffer>
  industryFilters: Array<LoyaltyOffersHubIndustryFilterOption>
}

function LoyaltyOffersHubPartnerOffersSection({ offers, industryFilters }: Props) {
  const intl = useIntl()
  const [activeIndustryFilter, setActiveIndustryFilter] = useState<string>(LOYALTY_OFFERS_HUB_ALL_INDUSTRY_FILTER)

  const filterOptions = useMemo(() => {
    const allIndustryFilterLabel = intl.formatMessage({
      id: 'ZyXTRtYA7XiA-alFNQDD',
      defaultMessage: 'All',
      description: 'Filter chip label showing all Societe partner offers',
    })

    return industryFilters.map(industryFilter => industryFilter === LOYALTY_OFFERS_HUB_ALL_INDUSTRY_FILTER ? {
      label: allIndustryFilterLabel,
      value: industryFilter,
    } : {
      label: industryFilter.label,
      value: industryFilter.industry,
    })
  }, [industryFilters, intl])

  const filteredOffers = useMemo(
    () => activeIndustryFilter === LOYALTY_OFFERS_HUB_ALL_INDUSTRY_FILTER ?
      offers :
        offers.filter(offer => offer.industry === activeIndustryFilter),
    [activeIndustryFilter, offers],
  )

  const handleIndustryFilterChange = useCallback((nextIndustryFilter: string) => {
    setActiveIndustryFilter(nextIndustryFilter)
  }, [])

  const partnerOffersHeading = intl.formatMessage({
    id: 'Gm9ArTQWzzWSg1wC9Q7f',
    defaultMessage: 'Partner Offers',
    description: 'Heading for partner offers section on the Societe offers hub page',
  })

  if (!offers.length) return null

  return <Pane background="none" padding="40 0">
    <Group direction="vertical" gap={24}>
      <Heading id={LOYALTY_OFFERS_HUB_PARTNER_OFFERS_HASH} variant="heading2">
        {partnerOffersHeading}
      </Heading>
      {filterOptions.length > 1 && <OfferCardCarouselSectionFilters
        options={filterOptions}
        value={activeIndustryFilter}
        onChange={handleIndustryFilterChange}
      />}
      <LoyaltyOffersHubOfferGrid
        key={activeIndustryFilter}
        offers={filteredOffers}
      />
    </Group>
  </Pane>
}

export default LoyaltyOffersHubPartnerOffersSection
